export const ASSETS = {
    heroVideo:
        "https://customer-assets.emergentagent.com/job_property-premium-1/artifacts/ifdd4o4c_Marlea%20Reel%201080P.mp4",
    beforeAfterVideo:
        "https://customer-assets.emergentagent.com/job_property-premium-1/artifacts/uyp1h62r_Marlea%20test.mp4",
    beforeAfterPhoto:
        "https://customer-assets.emergentagent.com/job_property-premium-1/artifacts/itih8kyx_Untitled%20design%20-%202026-04-24T114035.391.png",
    marleaLogo:
        "https://customer-assets.emergentagent.com/job_property-premium-1/artifacts/vtv9c9rh_Transparant.png",
    horizontalVideos: [
        "https://www.youtube.com/embed/ab6j5H0oK2M?autoplay=1&mute=1&loop=1&playlist=ab6j5H0oK2M&controls=1&modestbranding=1&rel=0",
        "https://www.youtube.com/embed/SlT6M_Lp9r4?autoplay=1&mute=1&loop=1&playlist=SlT6M_Lp9r4&controls=1&modestbranding=1&rel=0",
    ],
    ambientBg:
        "https://static.prod-images.emergentagent.com/jobs/f2eafeba-7220-4dc2-952d-38fa946efa6e/images/5e67393bd7d7af05f3fde4ca8bfedeeb45b2b0bc2d59cc126f69e227cd7ebb9b.png",
    testimonials: [
        "https://images.pexels.com/photos/14585727/pexels-photo-14585727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzc3MDIyMjU1fDA&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzc3MDIyMjU1fDA&ixlib=rb-4.1.0&q=85",
    ],
};
